(function () {
  "use strict";

  /* -------------------------------------------------------
   * 1) Vanilla DOM: one DOMContentLoaded for all handlers
   * ------------------------------------------------------- */
  document.addEventListener("DOMContentLoaded", function () {
    /* Search popup toggle */
    (function () {
      const searchIcon   = document.querySelector('.header__icon.header__icon--search');
      const headerGroup  = document.querySelector('.shopify-section-group-header-group.section-header-navigation');
      const targetDialog = document.querySelector('.search_details.search_details--popup');
      if (!searchIcon || !headerGroup || !targetDialog) return;

      searchIcon.addEventListener('click', function () {
        setTimeout(() => {
          const headerSection = document.querySelector('.shopify-section.section-header-navigation.shopify-section-header-sticky');
          if (!headerSection) return;
          document.body.classList.add('open_search_menu');
          headerGroup.classList.add('sticky-search-menu-open');
          headerSection.classList.add('sticky-search-menu-open');
          targetDialog.setAttribute('open', 'open');
        }, 300);
      });
    })();

    /* Wrap repeated FAQ sections (site-wide + product) */
    (function () {
      const fullFaq = document.querySelectorAll('section.fullwidth-faq-section');
      if (fullFaq.length) {
        const wrapper = document.createElement('div');
        wrapper.className = 'all-faq-pages-wrapper';
        fullFaq[0].parentNode.insertBefore(wrapper, fullFaq[0]);
        fullFaq.forEach(sec => wrapper.appendChild(sec));
      }

      const prodFaq = document.querySelectorAll('section.product-faq-section');
      if (prodFaq.length) {
        const wrapper = document.createElement('section');
        wrapper.className = 'all-product-faq-pages-wrapper';
        prodFaq[0].parentNode.insertBefore(wrapper, prodFaq[0]);
        prodFaq.forEach(sec => wrapper.appendChild(sec));
      }
    })();

    /* Simple accordion (no jQuery) */
    (function () {
      const titles = document.querySelectorAll(".accordion-title");
      if (!titles.length) return;
      titles.forEach((t) => {
        t.addEventListener("click", function () {
          const content = this.nextElementSibling;
          this.classList.toggle("active");
          content && (content.style.maxHeight = this.classList.contains("active") ? (content.scrollHeight + "px") : null);

          // close others
          titles.forEach((other) => {
            if (other !== this) {
              other.classList.remove("active");
              const o = other.nextElementSibling;
              if (o) o.style.maxHeight = null;
            }
          });
        });
      });
    })();

    /* Click-to-play inline video */
    (function () {
      const video = document.getElementById('customVideo');
      const playButton = document.getElementById('playButton');
      if (!video || !playButton) return;

      playButton.addEventListener('click', function () {
        video.play().catch(() => {});
        playButton.style.display = 'none';
      });

      video.addEventListener('click', function () {
        if (!video.paused) {
          video.pause();
          playButton.style.display = 'inline-flex';
        } else {
          video.play().catch(() => {});
          playButton.style.display = 'none';
        }
      });
    })();

    /* Subtotal: hide at qty=1, show at qty>1 */
    (function () {
      function syncSubtotal(input) {
        var line = input.closest('.quantity-line');
        var subtotal = line && line.querySelector('.productView-subtotal');
        if (!subtotal) return;
        subtotal.classList.toggle('qty-visible', parseInt(input.value, 10) > 1);
      }

      document.addEventListener('change', function (e) {
        if (e.target.classList.contains('quantity__input')) syncSubtotal(e.target);
      });

      document.addEventListener('click', function (e) {
        var btn = e.target.closest('.quantity__button');
        if (!btn) return;
        var qty = btn.closest('.quantity');
        var input = qty && qty.querySelector('.quantity__input');
        if (input) setTimeout(function () { syncSubtotal(input); }, 0);
      });
    })();

    /* Mobile: move product gallery between title and short description */
    (function () {
      if (!window.matchMedia('(max-width: 767px)').matches) return;
      var gallery = document.querySelector('.halo-productView-left');
      var slot = document.getElementById('pbb-gallery-slot');
      if (!gallery || !slot) return;
      slot.replaceWith(gallery);
      /* Slick stores pixel widths from the original position.
         A resize event tells every slick instance to recalculate. */
      setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
      }, 50);
    })();
  });

  /* -------------------------------------------------------
   * 2) Swiper helper (scopes nav + duplicate init guard)
   * ------------------------------------------------------- */
  function initSwiperIfExists(selector, options, hooks) {
  var el = document.querySelector(selector);
  if (!el || !window.Swiper) return;

  if (el.dataset.swiperInited === '1') return; // guard

  var opts = Object.assign({}, options || {});

  // ---- Navigation (scoped + safe) ----
  if (opts.navigation !== false) {
    var nav = Object.assign({}, opts.navigation || {});
    nav.nextEl = (typeof nav.nextEl === 'string' ? el.querySelector(nav.nextEl) : nav.nextEl) || el.querySelector('.swiper-button-next');
    nav.prevEl = (typeof nav.prevEl === 'string' ? el.querySelector(nav.prevEl) : nav.prevEl) || el.querySelector('.swiper-button-prev');
    if (nav.nextEl && nav.prevEl) opts.navigation = nav; else delete opts.navigation;
  }

  // ---- Pagination (scoped + safe) ----
  if (opts.pagination) {
    var pag = Object.assign({}, opts.pagination);
    pag.el = (typeof pag.el === 'string' ? el.querySelector(pag.el) : pag.el) || el.querySelector('.swiper-pagination');
    if (pag.el) opts.pagination = pag; else delete opts.pagination;
  }

  var sw = new Swiper(el, opts);
  el.dataset.swiperInited = '1';
  if (hooks && typeof hooks === 'function') hooks(sw);
  return sw;
}


  /* Video slider globals */
  var _videoMuted = true;
  var _videoPlaying = false;
  var _helioVideoSwiper = null;

  function applyMuteStateToAll() {
    document.querySelectorAll('.helio_videos_slider .reel_videos').forEach(function(v) { v.muted = _videoMuted; });
    document.querySelectorAll('.helio_videos_slider .slidervideocontrol').forEach(function(c) {
      var im = c.querySelector('.icon-muted');
      var iu = c.querySelector('.icon-unmuted');
      if (im) im.classList.toggle('hidden', !_videoMuted);
      if (iu) iu.classList.toggle('hidden', _videoMuted);
    });
  }

  function pauseAllVideos() {
    document.querySelectorAll('.helio_videos_slider .slidervideocontrol').forEach(function(c) {
      var v = c.querySelector('video');
      if (v) {
        v._playId = (v._playId || 0) + 1;
        v.pause();
      }
      var pb = c.querySelector('.custom-play-btn');
      var mb = c.querySelector('.custom-mute-btn');
      if (pb) pb.classList.remove('hidden');
      if (mb) mb.classList.add('hidden');
    });
  }

  function playActiveVideo(container) {
    pauseAllVideos();
    var video = container.querySelector('video');
    var playBtn = container.querySelector('.custom-play-btn');
    var muteBtn = container.querySelector('.custom-mute-btn');
    if (!video) return;
    _videoPlaying = true;
    video.muted = _videoMuted;
    if (playBtn) playBtn.classList.add('hidden');
    if (muteBtn) muteBtn.classList.remove('hidden');
    var playId = video._playId;
    video.play().catch(function() {
      if (video._playId !== playId) return;
      _videoPlaying = false;
      if (playBtn) playBtn.classList.remove('hidden');
      if (muteBtn) muteBtn.classList.add('hidden');
    });
  }

  function controlVideos(swiperInstance) {
    if (!swiperInstance || !swiperInstance.slides) return;
    pauseAllVideos();
  }

  /* -------------------------------------------------------
   * 3) Swiper blocks (after dom + swiper)
   * ------------------------------------------------------- */
  whenLibs(['dom', 'swiper'], function () {
    initSwiperIfExists(".logo-slider-client", {
      slidesPerView: 5,
      spaceBetween: 30,
      loop: true,
      autoplay: { delay: 3000, disableOnInteraction: false },
      breakpoints: { 320:{slidesPerView:2}, 480:{slidesPerView:4}, 1025:{slidesPerView:5} }
    });

    initSwiperIfExists(".testimonials-client", {
      slidesPerView: 3,
      spaceBetween: 30,
      centeredSlides: true,
      loop: true,
      navigation: { nextEl: document.querySelector('.swiper-button-next'), prevEl: document.querySelector('.swiper-button-prev') },
      autoplay: { delay: 3000, disableOnInteraction: false },
      breakpoints: {
        320:{slidesPerView:1,spaceBetween:12},
        768:{slidesPerView:2,spaceBetween:15},
        992:{slidesPerView:3,spaceBetween:30}
      }
    });

    initSwiperIfExists(".product-slider-client", {
      slidesPerView: 3,
      spaceBetween: 30,
      loop: true,
      navigation: { nextEl: '.swiper-button-nextsc', prevEl: '.swiper-button-prevsc' },
      autoplay: { delay: 3000, disableOnInteraction: false },
      breakpoints: {
        320:{slidesPerView:1,spaceBetween:12},
        768:{slidesPerView:2,spaceBetween:15},
        992:{slidesPerView:3,spaceBetween:30}
      }
    });

    initSwiperIfExists(".helio-cuatom-hilightedreview-data .swiper", {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      autoplay: { delay: 2500, disableOnInteraction: false }
    });

    initSwiperIfExists(".focus-card-slider", {
      slidesPerView: 3,
      spaceBetween: 24,
      loop: true,
      navigation: { nextEl: document.querySelector('.swiper-button-nextfc'), prevEl: document.querySelector('.swiper-button-prevfc') },
      breakpoints: {
        320:{slidesPerView:1,spaceBetween:15},
        552:{slidesPerView:2,spaceBetween:15},
        768:{slidesPerView:2,spaceBetween:15},
        992:{slidesPerView:3,spaceBetween:24}
      }
    });

    initSwiperIfExists(".visibleresult-slider-client", {
      slidesPerView: 3,
      spaceBetween: 25,
      loop: false,
      navigation: { nextEl: document.querySelector('.swiper-button-next'), prevEl: document.querySelector('.swiper-button-prev') },
      breakpoints: {
        0:{slidesPerView:1,spaceBetween:25},
        481:{slidesPerView:2,spaceBetween:25},
        768:{slidesPerView:2,spaceBetween:25},
        1199:{slidesPerView:3,spaceBetween:25},
        1280:{slidesPerView:3,spaceBetween:25}
      }
    });

    initSwiperIfExists(".healthybenifit", {
      slidesPerView: 4,
      loop: true,
      navigation: { nextEl: document.querySelector('.swiper-button-next'), prevEl: document.querySelector('.swiper-button-prev') },
      breakpoints: {
        320:{slidesPerView:1},
        768:{slidesPerView:2},
        992:{slidesPerView:3},
        1200:{slidesPerView:4}
      }
    });

    initSwiperIfExists(".use-case-slider", {
      slidesPerView: 3,
      spaceBetween: 24,
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
      breakpoints: {
        320:{slidesPerView:1,spaceBetween:15},
        552:{slidesPerView:2,spaceBetween:15},
        768:{slidesPerView:3,spaceBetween:15},
        992:{spaceBetween:24}
      }
    });

    initSwiperIfExists(".helio_videos_slider", {
      slidesPerView: 5,
      spaceBetween: 30,
      centeredSlides: true,
      loop: true,
      navigation: { nextEl: '.swiper-button-nextvid', prevEl: '.swiper-button-prevvid' },
      loopAdditionalSlides: 5,
      breakpoints: {
        0: { slidesPerView: 1.25, spaceBetween: 12 },
        481: { slidesPerView: 3, spaceBetween: 15 },
        768: { slidesPerView: 3, spaceBetween: 20 },
        1199: { slidesPerView: 5, spaceBetween: 25 }
      },
      on: {
        init: function () {
          _helioVideoSwiper = this;
          controlVideos(this);
          var swiper = this;
          var observer = new IntersectionObserver(function(entries) {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            Array.from(swiper.slides).forEach(function(slide) {
              if (slide.classList.contains('swiper-slide-duplicate')) return;
              var v = slide.querySelector('video');
              if (v) { v.preload = 'auto'; v.load(); }
            });
          }, { rootMargin: '200px' });
          observer.observe(swiper.el);
          swiper.el.addEventListener('click', function(e) {
            var slide = e.target.closest('.swiper-slide');
            if (!slide || slide.classList.contains('swiper-slide-active')) return;
            var domIndex = Array.from(swiper.slides).indexOf(slide);
            if (domIndex >= 0) {
              swiper.slideTo(domIndex);
            }
          });
        },
        slideChangeTransitionEnd: function () {
          var shouldAutoPlay = _videoPlaying;
          controlVideos(this);
          if (shouldAutoPlay) {
            var activeSlide = this.slides[this.activeIndex];
            if (!activeSlide) return;
            var container = activeSlide.querySelector('.slidervideocontrol');
            if (container) playActiveVideo(container);
          }
        },
        resize: function () { controlVideos(this); }
      }
    });

    document.querySelectorAll('.helio_videos_slider .swiper-slide:not(.swiper-slide-duplicate) .slidervideocontrol').forEach(function(container) {
      var video = container.querySelector('video');
      var playBtn = container.querySelector('.custom-play-btn');
      var muteBtn = container.querySelector('.custom-mute-btn');
      if (!video || !playBtn || !muteBtn) return;

      video.disablePictureInPicture = true;
      video.setAttribute('playsinline', '');

      playBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        var slide = container.closest('.swiper-slide');
        if (slide && !slide.classList.contains('swiper-slide-active') && _helioVideoSwiper) {
          var domIndex = Array.from(_helioVideoSwiper.slides).indexOf(slide);
          if (domIndex >= 0) {
            _videoPlaying = true;
            _helioVideoSwiper.slideTo(domIndex);
          }
        } else {
          playActiveVideo(container);
        }
      });

      video.addEventListener('click', function() {
        var slide = container.closest('.swiper-slide');
        if (slide && !slide.classList.contains('swiper-slide-active')) return;
        if (video.paused) {
          playActiveVideo(container);
        } else {
          _videoPlaying = false;
          video.pause();
        }
      });

      muteBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        _videoMuted = !_videoMuted;
        applyMuteStateToAll();
      });

      video.addEventListener('pause', function() {
        playBtn.classList.remove('hidden');
        muteBtn.classList.add('hidden');
      });

      video.addEventListener('ended', function() {
        _videoPlaying = false;
        playBtn.classList.remove('hidden');
        muteBtn.classList.add('hidden');
      });
    });
  });
  /* -------------------------------------------------------
   * 4) jQuery blocks (after dom + vendor)
   * ------------------------------------------------------- */
  whenLibs(['dom','vendor'], function () {
    // Smooth scroll for TOC links
    jQuery(document).on("click", "#TOC_container a", function (event) {
      event.preventDefault();
      var href = jQuery(this).attr('href');
      if (href && href.includes("#")) {
        var id = '#' + href.split("#")[1];
        var $t = jQuery(id);
        var top = ($t.length ? $t.offset().top : 0) - 175;
        jQuery('html, body').animate({ scrollTop: top }, 2000);
      } else if (href) {
        window.location.href = href;
      }
      if (jQuery(window).width() <= 1024) {
        jQuery('.halo-sidebar-close').trigger('click');
      }
    });

    // Phone numeric only
    jQuery('input[name="contact[phone]"]').on('input', function () {
      this.value = this.value.replace(/[^0-9]/g, '').slice(0, 15);
    });

    // Product page filter toggle (desktop only)
    if (jQuery(window).width() > 1024) {
      jQuery(".facets-wrapper").hide();
      jQuery(".fillter_toggel").on('click', function () {
        jQuery(".facets-wrapper").toggle();
        jQuery("#CollectionProductGrid").toggleClass("div_open");
        jQuery(".facets-wrapper .halo-sidebar-wrapper").removeClass("scroll-trigger--offscreen");
      });
    }

    // Current menu indicator
    jQuery('.main-menu--wrapper li a[aria-current="page"]').css('color', 'var(--color-accent) !important');

    // Prevent qty input from typing
    jQuery('.form-input.quantity.cart-item-qty-input').on('keydown', function (e) {
      e.preventDefault();
    });

    // Comparison table "show more"
    jQuery(".helio_custom_comp_table_loadmore").on('click', function () {
      jQuery(".comprison_table_wrapper").toggleClass("fullhight_class");
      jQuery(this).toggleClass("less_moreload");
      if (jQuery(".comprison_table_wrapper").hasClass("fullhight_class")) {
        jQuery(this).text("Show Fewer Features");
      } else {
        jQuery(this).text("Show More Features");
        var top = (jQuery('.comprison_table_wrapper').offset()?.top ?? 0) - 180;
        jQuery('html, body').animate({ scrollTop: top }, 500);
      }
    });

    // Right comparison table "show more"
    jQuery(".helio_table_loadmore").on('click', function () {
      jQuery(".comprison_table_wrapper.helio_right_comp_table").toggleClass("fullhight_class");
      jQuery(this).toggleClass("less_moreload");
      if (jQuery(".comprison_table_wrapper").hasClass("fullhight_class")) {
        jQuery(this).text("Show Fewer Features");
      } else {
        jQuery(this).text("Show More Features");
        var top = (jQuery('.comprison_table_wrapper.helio_right_comp_table').offset()?.top ?? 0) - (jQuery('header').outerHeight() || 0);
        jQuery('html, body').animate({ scrollTop: top }, 500);
      }
    });

    // Equalize card heights + on load + debounced resize
    function equalizeCardHeights() {
      var $cards = jQuery('.features-card-box');
      if (!$cards.length) return;
      $cards.css('height', 'auto');
      var max = 0;
      $cards.each(function () {
        var h = jQuery(this).outerHeight();
        if (h > max) max = h;
      });
      $cards.css('height', max + 'px');
    }
    equalizeCardHeights();
    jQuery(window).on('load', equalizeCardHeights);

    var _eqTimer;
    jQuery(window).on('resize', function () {
      clearTimeout(_eqTimer);
      _eqTimer = setTimeout(equalizeCardHeights, 150);
    });
  });

  /* -------------------------------------------------------
   * 5) Globo heading mutation change (with guard)
   * ------------------------------------------------------- */
  (function () {
    const observer = new MutationObserver(() => {
      document.querySelectorAll("h3.globo-heading").forEach(el => {
        if (el.dataset.hUpgraded === '1') return;
        const h2 = document.createElement("h2");
        h2.innerHTML = el.innerHTML;
        h2.className = el.className;
        h2.dataset.hUpgraded = '1';
        el.replaceWith(h2);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();

})();
